import React from "react";

/**
 * When debugging run-away component re-renders, you sometimes need a quick
 * helper that stops component re-renders so that the constant re-renders
 * don't bring down the JS main thread.
 *
 * This hook will only allow `maxRenders` every `resetIntervalMs` (milliseconds)
 * before throwing `new Error("Max renders exceeded!");`.
 *
 * @param maxRenders
 * @param resetIntervalMs
 */
export function useMaxRenders(
  maxRenders: number = 30,
  resetIntervalMs: number = 1000
) {
  const rendersCount = React.useRef<number>(0);
  if (rendersCount.current >= maxRenders) {
    throw new Error("Max renders exceeded!");
  }
  rendersCount.current = rendersCount.current + 1;
  React.useEffect(() => {
    const interval = setInterval(() => {
      rendersCount.current = 0;
    }, resetIntervalMs);
    return () => clearInterval(interval);
  }, []);
}
